import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { CitationService } from "../../service/citation/citation.service";
import { ContractService } from "../../service/contract/contract.service";
import { Attendance } from "../../class/attendance";
import {
  Message,
  ConfirmationService,
  LazyLoadEvent,
  SelectItem,
} from "primeng/primeng";
import { TranslateService } from "@ngx-translate/core";
import {
  FormGroup,
  AbstractControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationsService } from "../../../../theme/services/notifications/notifications.service";
import { HasPermissionService } from "../../service/has-permission/has-permission.service";
import { Candidate } from "../../class/candidate";
import { config } from "../../../../../environments/config";
import { UploadFilesService } from "../../service/upload-files/upload-files.service";
import { CandidateService } from "../../service/candidate/candidate.service";
import { AttendanceJustificationService } from "../../service/attendance-justification/attendance-justification.service";
import { CustomerGuideService } from "../../service/customer-guide/customer-guide.service";
import { DocumentProfileSurveyService } from "../../service/document-profile-survey/document-profile-survey.service";

import { formatDate } from "../../../../theme/functions/formatDate.function";
import { calendarES } from "../../../../theme/functions/calendarES";
@Component({
  selector: "app-citations",
  templateUrl: "./citations.component.html",
  styleUrls: ["./citations.component.scss"],
})
export class CitationsComponent implements OnInit, OnDestroy {
  @Input() identification_number: string;
  @Input() only_attended: boolean;

  public promiseForm: Promise<any>;

  public msgs: Message[] = [];
  public citations: Attendance[];
  public recruits: Attendance[];
  public selectCitation: Attendance;
  public CitationID: Number = 0;
  public modNew = false;
  public modView = false;
  public openCitation = false;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;

  public per_page_documentation: number;

  public modViewDialog: boolean;
  public citationEditCitation: any;
  public idEditRequisition: number;
  public idEditCitation: number;
  public statusEditCitation: string;
  public typeEditCitation: string;
  public displaySidebarJustification: boolean;

  public form2: FormGroup;
  public justification: AbstractControl;
  public listCitationJustification: any[];
  public informationCustomerGuide: any[];
  edit1: Attendance;

  public form3: FormGroup;
  public company_id_filter: AbstractControl;
  public candidate_id_filter: AbstractControl;
  public recruited_by_id_filter: AbstractControl;
  public interviewed_by_id_filter: AbstractControl;
  public documental_analysis_by_id_filter: AbstractControl;
  public hire_by_id_filter: AbstractControl;
  public start_admission_date_filter: AbstractControl;
  public end_admission_date_filter: AbstractControl;
  public start_date_send_doc_man_filter: AbstractControl;
  public end_date_send_doc_man_filter: AbstractControl;
  public start_date_medical_appointment_filter: AbstractControl;
  public end_date_medical_appointment_filter: AbstractControl;
  public start_suggested_date_medical_exam_filter: AbstractControl;
  public end_suggested_date_medical_exam_filter: AbstractControl;
  public hiring_analyst_id_filter: AbstractControl;
  public venue_id_filter: AbstractControl;
  public send_customer_filter: AbstractControl;
  public sendcustomerOptions: SelectItem[];
  public send_hiring_filter: AbstractControl;
  public manager_send_hiring_sign_by_id_filter: AbstractControl;
  public sendhiringOptions: SelectItem[];
  public status_medical_examen_filter: AbstractControl;
  public result_hired_filter: AbstractControl;
  public statusMedicalExamenOptions: SelectItem[];
  public resultHiredOptions: SelectItem[];
  public send_hiring_sign_filter: AbstractControl;
  public sendHiringSignOptions: SelectItem[];
  public send_documental_management_filter: AbstractControl;
  public sendDocumentalManagementOptions: SelectItem[];
  public result_documental_analysis_filter: AbstractControl;
  public resultDocumentalAnalysisOptions: SelectItem[];
  public send_income_order_filter: AbstractControl;
  public citacions_sources_filter: AbstractControl;
  public sendIncomeOrderOptions: SelectItem[];
  public citacionsSourcesOptions: SelectItem[];
  public statusHiringOptions: SelectItem[];

  public employeePositionToLoadSelection: string;
  public employeePositionDocumentalToLoadSelection: string;
  public employeePositionHireToLoadSelection: string;

  public modExportDialog: boolean;
  public modDaviviendaExportDialog: boolean;
  public modImportDialog: boolean;
  public modRecruitmentDialog: boolean;

  public form4: FormGroup;

  public f4_date_start: AbstractControl;
  public f4_date_end: AbstractControl;
  public f4_venue_id: AbstractControl;
  public f4_company_id: AbstractControl;
  public f4_status_filter: AbstractControl;
  public f4_export_type_filter: AbstractControl;
  public f4_status_hiring: AbstractControl;

  public form5: FormGroup;
  public mobile_send: AbstractControl;
  public message_send: AbstractControl;

  public form_davivienda_export: FormGroup;

  public form_date_start: AbstractControl;
  public form_date_end: AbstractControl;
  public form_export_type: AbstractControl;

  public apiUrl = config.API_ROOT;

  public params_id_requisition: number;

  public viewType: string;

  public lists: any;

  public selectCandidate: Candidate;
  public modViewDialogCandidate: boolean;
  public modViewDialogWhatsapp: boolean;

  public modViewDialogDocumentation: boolean;

  public sticky: boolean;

  public reloadInterval: any;
  public loading: boolean;
  public modViewDialogExchangeCitation: boolean;
  public modViewDialogNotifyCitations: boolean;
  public modViewDialogApproveCitations: boolean;
  public showbuttonExchangeCitation: boolean;
  public showbuttonNotifyApproveCitations: boolean;

  public notifyCustomerform: FormGroup;
  public approveCitationsForm: FormGroup;

  public sortHireToday: boolean;
  public sortHire: boolean;
  public query: string;

  public first = 0;
  public timeReload: number = 1200000;
  public statusOptions: SelectItem[];
  public result: any;
  public ReportTypeExportOptions: SelectItem[];
  public selectedReportTypeExportOptions: { label: string; value: string };

  public ReportTypeDaviviendaExportOptions: SelectItem[];
  public selectedReportTypeDaviviendaExportOption: {
    label: string;
    value: string;
  };

  public filters: any[];

  public es: any;

  public allinone: boolean;

  public uploadedImportFile: any[] = [];
  public prewiewImportFile: any;
  public promiseImportFile: Promise<any>;

  public candidate: Candidate[];

  public uploadedAttachment: any[] = [];
  public prewiewFileAttachment: any[] = [];
  public promiseAttachment: Promise<any>;
  public listDocuments: any[] = [];
  public selectCitationType: string;
  public loading_upload: boolean;
  public requisitionTrasnfer: any;
  public selectCitationsTransf: any[];
  public resultSelectCitationsTransf: any[];
  public lengthresultSelectCitationsTransf: number;

  public editPart;
  public editEventPart;

  public form6: FormGroup;
  public requisition_id_transfer: AbstractControl;
  public showrequisitionTransfer: boolean;
  public showrequisitionTransferClose: boolean;
  public requisitionTrasnferOk: boolean;
  public loadingShowTransfReq: boolean;

  public modViewDialogUploadCitationExc: boolean;
  public citationsUploadResult: any;
  public citationsUploadResultStatus: number = 0;
  public lengthCitationsUploadResult: number = 0;

  public listDocumentsHV: any[] = [];
  public copyHV: boolean = false;

  public gestSignHireDialog: boolean = false;
  public employeeSelected: string;

  public form7: FormGroup;
  public date_medical_appointment: AbstractControl;
  public lab_medical_exams: AbstractControl;

  public getMedicalAppointmentLaboratoryDialog: boolean = false;

  public form8: FormGroup;
  public instruction: AbstractControl;

  public form9: FormGroup;
  public send_doc_man_obs: AbstractControl;

  public form10: FormGroup;
  public sendDocumentalManDialog: boolean = false;
  public manager_send_hiring_sign_by_id: AbstractControl;

  public role_id: any = null;

  constructor(
    public citationService: CitationService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public activatedRoute: ActivatedRoute,
    public hasPermissionService: HasPermissionService,
    public fb: FormBuilder,
    private notificationsService: NotificationsService,
    public uploadFilesService: UploadFilesService,
    public candidateService: CandidateService,
    public attendanceJustificationService: AttendanceJustificationService,
    public contractService: ContractService,
    public customerGuideService: CustomerGuideService,
    public documentProfileSurveyService: DocumentProfileSurveyService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.es = calendarES();

    this.modViewDialogCandidate = false;
    this.modViewDialogWhatsapp = false;
    this.viewType = "list";

    this.modViewDialogDocumentation = false;
    this.displaySidebarJustification = false;

    this.ReportTypeDaviviendaExportOptions = [
      {
        label: "Reporte de operaciones - General",
        value: "Reporte de operaciones - General",
      },
    ];

    this.ReportTypeExportOptions = [
      {
        label: "Reporte Citación - General",
        value: "Reporte Citación - General",
      },
      {
        label: "Reporte Citación - General Tiempos",
        value: "Reporte Citación - General Tiempos",
      },
      {
        label: "Reporte Citación - Percepción inicial",
        value: "Reporte Citación - Percepción inicial",
      },
      {
        label: "Reporte Citación - Contratado Por",
        value: "Reporte Citación - Contratado Por",
      },
      {
        label: "Reporte Citación - Contratado Diario",
        value: "Reporte Citación - Contratado Diario",
      },
      {
        label: "Reporte Citación - Reclutamiento",
        value: "Reporte Citación - Reclutamiento",
      },
      {
        label: "Reporte Citación - Enviados a Gestión Documental",
        value: "Reporte Citación - Enviados a Gestión Documental",
      },
      {
        label: "Reporte Citación - Gestión Documental",
        value: "Reporte Citación - Gestión Documental",
      },
      {
        label: "Reporte Citación - Documentación",
        value: "Reporte Citación - Documentación",
      },
      {
        label: "Reporte Citación - Contratado por Fecha Ingreso",
        value: "Reporte Citación - Contratado por Fecha Ingreso",
      },
      {
        label: "Reporte Citación - Psicólogas",
        value: "Reporte Citación - Psicólogas",
      },
      {
        label: "Reporte Citación - Backup Claro",
        value: "Reporte Citación - Backup Claro",
      },
      {
        label: "Reporte Citación - Informe Documentos Contratados",
        value: "Reporte Citación - Informe Documentos Contratados",
      },
      {
        label: "Reporte Citación - Fecha de ingreso",
        value: "Reporte Citación - Fecha de ingreso",
      },
      {
        label: "Reporte Citación - Exámenes médicos",
        value: "Reporte Citación - Exámenes médicos",
      },
      {
        label: "Reporte Citación - Informe Gestión Reclutamiento",
        value: "Reporte Citación - Informe Gestión Reclutamiento",
      },
      {
        label: "Reporte Citación - Orden de ingreso / Servicio",
        value: "Reporte Citación - Orden de ingreso / Servicio",
      },
    ];

    this.resultHiredOptions = [
      { label: "Cualquiera", value: "" },
      { label: "Inicio", value: "Inicio" },
      { label: "Final", value: "Final" },
      { label: "Cancelado por el cliente", value: "Cancelado por el cliente" },
      { label: "Candidato desistió", value: "Candidato desistió" },
      { label: "Contratado", value: "Contratado" },
      { label: "Favorable", value: "Favorable" },
      { label: "Inejecución", value: "Inejecución" },
      { label: "Inexistencia", value: "Inexistencia" },
      { label: "No apto en ESC", value: "No apto en ESC" },
      { label: "No contratado", value: "No contratado" },
    ];

    this.sendcustomerOptions = [
      { label: "Todos Enviado al cliente", value: "" },
      { label: "Enviado al cliente", value: "Favorable" },
      { label: "No enviado al cliente", value: "null" },
    ];

    this.sendhiringOptions = [
      { label: "Todos Enviado contratación", value: "" },
      { label: "Sí", value: "Si" },
      { label: "No", value: "No" },
      { label: "Pendiente", value: "pending" },
      { label: "No contratado", value: "No contratado" },
    ];

    this.statusMedicalExamenOptions = [
      { label: "Cualquiera", value: "" },
      { label: "Autorizado", value: "Autorizado" },
      { label: "No apto", value: "No apto" },
      { label: "Compromiso", value: "Compromiso" },
      { label: "Favorable", value: "Favorable" },
      { label: "Aplazado", value: "Aplazado" },
      { label: "No asistió", value: "No asistió" },
      { label: "Inicio", value: "Inicio" },
      { label: "Fin", value: "Fin" },
      { label: "Candidato en atención", value: "Candidato en atención" },
      {
        label: "No ha llegado el examen médico al correo",
        value: "No ha llegado el examen médico al correo",
      },
      {
        label: "Se esta ampliando información",
        value: "Se esta ampliando información",
      },
      {
        label: "Pendiente cierre de historia clinica",
        value: "Pendiente cierre de historia clinica",
      },
    ];

    this.sendHiringSignOptions = [
      { label: "Todos Gestionar contratación", value: "" },
      { label: "Sí", value: 1 },
      { label: "No", value: "0, " },
    ];

    this.sendIncomeOrderOptions = [
      { label: "Todos Enviado a examenes", value: "" },
      { label: "Sí", value: "1" },
      { label: "No", value: "0" },
    ];

    this.citacionsSourcesOptions = [
      { label: "Todas Fuentes Operaciones", value: "" },
      { label: "ChatBox", value: "ChatBox" },
      { label: "Portal de candidatos", value: "Portal de candidatos" },
    ];

    this.statusHiringOptions = [
      { label: "Contratado", value: "Contratado" },
      { label: "Candidato desistió", value: "Candidato desistió" },
      { label: "Cancelado por el cliente", value: "Cancelado por el cliente" },
      { label: "Inejecución", value: "Inejecución" },
      { label: "Inexistencia", value: "Inexistencia" },
      { label: "No apto en ESC", value: "No apto en ESC" },
      { label: "No contratado", value: "No contratado" },
    ];

    this.sendDocumentalManagementOptions = [
      { label: "Todos Enviado Gestion Documental", value: "" },
      { label: "Sí", value: "1" },
      { label: "No", value: "0" },
    ];

    this.resultDocumentalAnalysisOptions = [
      { label: "Todos Resultado Analisis Documental", value: "" },
      { label: "No Apto", value: "No Apto" },
      { label: "Novedad", value: "Novedad" },
      { label: "Favorable", value: "Favorable" },
      { label: "Autorizado", value: "Autorizado" },
      { label: "Revisado", value: "Revisado" },
      { label: "Sin Documentos", value: "Sin Documentos" },
      { label: "No aplica", value: "No aplica" },
    ];

    this.form2 = fb.group({
      justification: [
        "",
        Validators.compose([Validators.required, Validators.minLength(2)]),
      ],
    });
    this.justification = this.form2.controls["justification"];
    this.form3 = fb.group({
      company_id_filter: [""],
      candidate_id_filter: [""],
      recruited_by_id_filter: [""],
      interviewed_by_id_filter: [""],
      documental_analysis_by_id_filter: [""],
      hire_by_id_filter: [""],
      start_admission_date_filter: [""],
      end_admission_date_filter: [""],
      start_date_send_doc_man_filter: [],
      end_date_send_doc_man_filter: [],
      start_date_medical_appointment_filter: [""],
      end_date_medical_appointment_filter: [],
      start_suggested_date_medical_exam_filter: [],
      end_suggested_date_medical_exam_filter: [],
      hiring_analyst_id_filter: [""],
      venue_id_filter: [""],
      send_customer_filter: [""],
      send_hiring_filter: [""],
      status_medical_examen_filter: [""],
      result_hired_filter: [""],
      send_hiring_sign_filter: [""],
      send_income_order_filter: [""],
      citacions_sources_filter: [""],
      send_documental_management_filter: [""],
      result_documental_analysis_filter: [""],
      manager_send_hiring_sign_by_id_filter: [""],
    });

    this.company_id_filter = this.form3.controls["company_id_filter"];
    this.candidate_id_filter = this.form3.controls["candidate_id_filter"];
    this.recruited_by_id_filter = this.form3.controls["recruited_by_id_filter"];
    this.interviewed_by_id_filter =
      this.form3.controls["interviewed_by_id_filter"];
    this.documental_analysis_by_id_filter =
      this.form3.controls["documental_analysis_by_id_filter"];
    this.hire_by_id_filter = this.form3.controls["hire_by_id_filter"];
    this.start_admission_date_filter =
      this.form3.controls["start_admission_date_filter"];
    this.end_admission_date_filter =
      this.form3.controls["end_admission_date_filter"];
    this.start_date_send_doc_man_filter =
      this.form3.controls["start_date_send_doc_man_filter"];
    this.end_date_send_doc_man_filter =
      this.form3.controls["end_date_send_doc_man_filter"];
    ((this.start_date_medical_appointment_filter =
      this.form3.controls["start_date_medical_appointment_filter"]),
      (this.end_date_medical_appointment_filter =
        this.form3.controls["end_date_medical_appointment_filter"]));
    this.start_suggested_date_medical_exam_filter =
      this.form3.controls["start_suggested_date_medical_exam_filter"];
    this.end_suggested_date_medical_exam_filter =
      this.form3.controls["end_suggested_date_medical_exam_filter"];
    this.hiring_analyst_id_filter =
      this.form3.controls["hiring_analyst_id_filter"];
    this.venue_id_filter = this.form3.controls["venue_id_filter"];
    this.send_customer_filter = this.form3.controls["send_customer_filter"];
    this.send_hiring_filter = this.form3.controls["send_hiring_filter"];
    this.status_medical_examen_filter =
      this.form3.controls["status_medical_examen_filter"];
    this.result_hired_filter = this.form3.controls["result_hired_filter"];
    this.send_hiring_sign_filter =
      this.form3.controls["send_hiring_sign_filter"];
    this.send_income_order_filter =
      this.form3.controls["send_income_order_filter"];
    this.citacions_sources_filter =
      this.form3.controls["citacions_sources_filter"];
    this.result_documental_analysis_filter =
      this.form3.controls["result_documental_analysis_filter"];
    this.send_documental_management_filter =
      this.form3.controls["send_documental_management_filter"];
    this.manager_send_hiring_sign_by_id_filter =
      this.form3.controls["manager_send_hiring_sign_by_id_filter"];

    this.employeePositionToLoadSelection = "5,6,21,38,68";
    this.employeePositionDocumentalToLoadSelection = "7,8";
    this.employeePositionHireToLoadSelection = "5,6,7,8,9,10,38,40,53";

    this.form4 = fb.group({
      f4_date_start: ["", [Validators.required]],
      f4_date_end: ["", [Validators.required]],
      f4_venue_id: [""],
      f4_company_id: [""],
      f4_status_filter: [""],
      f4_export_type_filter: [
        "",
        [Validators.required, Validators.minLength(1)],
      ],
      f4_status_hiring: [""],
    });

    this.f4_date_start = this.form4.controls["f4_date_start"];
    this.f4_date_end = this.form4.controls["f4_date_end"];
    this.f4_venue_id = this.form4.controls["f4_venue_id"];
    this.f4_company_id = this.form4.controls["f4_company_id"];
    this.f4_status_filter = this.form4.controls["f4_status_filter"];
    this.f4_status_filter.setValue("all");
    // this.f4_sources_filter = this.form4.controls['f4_sources_filter'];
    this.f4_export_type_filter = this.form4.controls["f4_export_type_filter"];
    this.f4_status_hiring = this.form4.controls["f4_status_hiring"];

    this.form5 = fb.group({
      mobile_send: [
        "",
        Validators.compose([Validators.required, Validators.minLength(2)]),
      ],
      message_send: [
        "",
        Validators.compose([Validators.required, Validators.minLength(2)]),
      ],
    });
    this.mobile_send = this.form5.controls["mobile_send"];
    this.message_send = this.form5.controls["message_send"];

    this.form6 = fb.group({
      requisition_id_transfer: [
        "",
        Validators.compose([Validators.required, Validators.minLength(2)]),
      ],
    });
    this.requisition_id_transfer =
      this.form6.controls["requisition_id_transfer"];

    this.form7 = fb.group({
      date_medical_appointment: [
        "",
        Validators.compose([Validators.required, Validators.minLength(2)]),
      ],
      lab_medical_exams: [
        "",
        Validators.compose([Validators.required, Validators.minLength(2)]),
      ],
    });
    this.date_medical_appointment =
      this.form7.controls["date_medical_appointment"];
    this.lab_medical_exams = this.form7.controls["lab_medical_exams"];

    this.form8 = fb.group({
      instruction: [
        "",
        Validators.compose([Validators.required, Validators.minLength(2)]),
      ],
    });
    this.instruction = this.form8.controls["instruction"];

    this.form9 = fb.group({
      send_doc_man_obs: ["", Validators.compose([Validators.minLength(2)])],
    });
    this.send_doc_man_obs = this.form9.controls["send_doc_man_obs"];

    this.form10 = fb.group({
      manager_send_hiring_sign_by_id: [
        null,
        Validators.compose([Validators.required, Validators.minLength(1)]),
      ],
    });
    this.manager_send_hiring_sign_by_id =
      this.form10.controls["manager_send_hiring_sign_by_id"];

    this.form_davivienda_export = fb.group({
      form_date_start: ["", [Validators.required]],
      form_date_end: ["", [Validators.required]],
      form_export_type: ["", [Validators.required, Validators.minLength(1)]],
    });
    this.form_date_start =
      this.form_davivienda_export.controls["form_date_start"];
    this.form_date_end = this.form_davivienda_export.controls["form_date_end"];
    this.form_export_type =
      this.form_davivienda_export.controls["form_export_type"];

    this.modViewDialogUploadCitationExc = false;
    this.allinone = false;
    if (this.hasPermission("get citation allinone")) {
      this.allinone = true;
    }

    this.modExportDialog = false;
    this.modDaviviendaExportDialog = false;
    this.modImportDialog = false;
    this.modRecruitmentDialog = false;

    this.sticky = false;
    this.loading = true;

    this.statusOptions = [
      { label: "Todas", value: "all" },
      { label: "Abierta", value: "Abierto" },
      { label: "En Proceso", value: "En Proceso" },
      { label: "Congelado", value: "Congelado" },
      { label: "Cerrada", value: "Cerrado" },
    ];

    this.listCitationJustification = [];
    this.informationCustomerGuide = [];
    this.listDocuments = [];
    this.editPart = undefined;
    this.editEventPart = undefined;

    this.totalRecords = 0;
    this.loading_upload = false;
    this.modViewDialogExchangeCitation = false;
    this.modViewDialogNotifyCitations = false;
    this.modViewDialogApproveCitations = false;
    this.showbuttonExchangeCitation = false;
    this.showbuttonNotifyApproveCitations = false;
    this.showrequisitionTransfer = false;
    this.showrequisitionTransferClose = false;
    this.requisitionTrasnferOk = false;
    this.loadingShowTransfReq = false;
    this.lengthresultSelectCitationsTransf = 0;

    this.approveCitationsForm = fb.group({
      customer_approved_id: [
        null,
        Validators.compose([Validators.required, Validators.minLength(1)]),
      ],
      authorization_observations: [
        "",
        Validators.compose([Validators.maxLength(500)]),
      ],
    });

    this.notifyCustomerform = fb.group({
      customer_email: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.pattern(
            "^[a-z0-9]+(.[_a-z0-9]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,15})$",
          ),
        ]),
      ],
      customer_whatsApp: [
        "",
        Validators.compose([
          Validators.minLength(7),
          Validators.maxLength(10),
          Validators.pattern("^[0-9]*$"),
        ]),
      ],
    });
  }

  ngOnInit() {
    this.filters = [];

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params["id_requisition"]) {
        this.params_id_requisition = Number(params["id_requisition"]);
      }
    });

    if (this.identification_number) {
      this.getCandidate(this.identification_number);
    }

    this.page = 1;
    this.per_page = 10;
    this.sort = "-citations.id";

    this.per_page_documentation = 100;

    this.reloadInterval = setInterval(() => {
      this.filter();
    }, this.timeReload);

    this.role_id = JSON.parse(localStorage.getItem("profile")).roles[0].id;
  }

  public ngOnChanges() {
    if (this.only_attended) {
      this.citations = [];
      this.recruits = [];
      this.loading = true;
    }
  }

  ngOnDestroy() {
    // Will clear when component is destroyed e.g. route is navigated away from.
    clearInterval(this.reloadInterval);
  }

  public loadCitationsLazy(event: LazyLoadEvent) {
    this.page = event.first / this.per_page + 1;

    if (event.sortField) {
      if (event.sortOrder === -1) {
        this.sort = "-" + event.sortField;
      } else {
        this.sort = event.sortField;
      }
    } else {
      this.sort = "-citations.start_send_hiring_sign";
    }

    if (event.globalFilter) {
      this.query = event.globalFilter;
    } else {
      this.query = undefined;
    }

    this.filter();
    this.restartTimer();
  }

  public getCitations() {
    this.loading = true;
    this.citationService
      .getCitation(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters,
      )
      .toPromise()
      .then(
        (response) => {
          this.loading = false;
          this.citations = response.json().data;

          if (
            response.json().meta.total > response.json().meta.total_filtered
          ) {
            this.totalRecords = response.json().meta.total_filtered;
          } else {
            this.totalRecords = response.json().meta.total;
          }
        },
        (error) => {
          this.loading = false;
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg,
                  );
                });
            });
        },
      );
  }

  public getCitationsByRequisitions(id: number) {
    this.loading = true;
    this.citationService
      .getCitationByRequisition(
        id,
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters,
      )
      .toPromise()
      .then(
        (response) => {
          this.loading = false;
          this.citations = response.json().data;
          if (
            response.json().meta.total > response.json().meta.total_filtered
          ) {
            this.totalRecords = response.json().meta.total_filtered;
          } else {
            this.totalRecords = response.json().meta.total;
          }
        },
        (error) => {
          this.loading = false;
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg,
                  );
                });
            });
        },
      );
  }

  public newCitation() {
    clearInterval(this.reloadInterval);
    this.modNew = !this.modNew;
    this.selectCitation = null;
  }

  public savedCitation(res) {
    this.msgs = [];
    this.msgs.push(res);
  }

  public cancelCitation(res) {
    this.selectCitation = null;
    this.modNew = false;
    this.modView = false;
    this.editPart = undefined;
    this.editEventPart = undefined;
    this.restartTimer();
  }

  public newRecruit() {
    this.modNew = !this.modNew;
    this.selectCitation = null;
    this.editPart = "recruited";
    this.editEventPart = undefined;
  }

  public edit(citation: Attendance) {
    clearInterval(this.reloadInterval);
    this.modNew = true;
    this.selectCitation = citation;
    this.editEventPart = undefined;
  }

  public validationPDFDocumentalHunterx(citationId) {
    this.citationService
      .validationPDFDocumentalHunterx(citationId)
      .toPromise()
      .then(
        (response: Blob) => {
          const blob = new Blob([response], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          window.open(url, "_blank");

          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 100);

          this.msgs = [];
          this.msgs.push({ severity: "success", summary: "validated" });

          if (this.params_id_requisition) {
            this.getCitationsByRequisitions(this.params_id_requisition);
          } else {
            this.getCitations();
          }
        },
        (error) => {
          this.notificationsService.growlNotify(
            "error",
            "Error al obtener el documento de validación",
          );
        },
      );
  }

  public view(citation: Attendance) {
    this.openCitation = true;
    this.selectCitation = citation;
    this.CitationID = citation.id;
    this.modView = true;
  }

  public deleteDialog(citation: Attendance) {
    let message;
    this.translate.get("Do you want to delete?").subscribe((res: string) => {
      message = res;
    });

    let header;
    this.translate.get("Delete Confirmation").subscribe((res: string) => {
      header = res;
    });

    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: "fa fa-trash",
      accept: () => {
        this.delete(citation);
      },
    });
  }

  public delete(citation: Attendance) {
    this.citationService
      .deleteCitation(citation.id)
      .toPromise()
      .then(
        (response) => {
          this.msgs = [];
          this.msgs.push({ severity: "success", summary: "deleted" });
          if (this.params_id_requisition) {
            this.getCitationsByRequisitions(this.params_id_requisition);
          } else {
            this.getCitations();
          }
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg,
                  );
                });
            });
        },
      );
  }

  public saveNotifyCustomer(values, citationsIds: number[]) {
    if (!values || !citationsIds || citationsIds.length === 0) {
      this.msgs.push({
        severity: "warn",
        summary: "Seleccione al menos una citación",
      });
      return;
    }
    // let citations_ids = citationsIds; // van los ids de las citations

    // values.requisition_id = this.idRequisition;

    if (values) {
      const promise =
        this.citationService.incomeOrderMassiveCustomerNotification(
          citationsIds,
          values,
        );
      this.promiseForm = promise.toPromise().then(
        (response) => {
          const result = response.json();
          this.notifyCustomerResult(result);
          this.modViewDialogNotifyCitations = false;
          // this.close.emit(true);
          // this.form.reset();
        },
        (error) => {
          this.msgs.push({ severity: "error", summary: "Error" });
        },
      );
    }
  }

  private notifyCustomerResult(result: any) {
    const emailSent = !!result.email_sent;
    const whatsappSent = !!result.whatsapp_sent;
    const whatsappAttempted = !!result.whatsapp_attempted;

    if (emailSent && (whatsappSent || !whatsappAttempted)) {
      this.notificationsService.growlNotify(
        "success",
        "Notificación enviada",
        whatsappAttempted
          ? "Correo enviado y WhatsApp enviado."
          : "Correo enviado.",
      );
    } else if (emailSent && whatsappAttempted && !whatsappSent) {
      this.notificationsService.growlNotify(
        "warn",
        "Notificación parcial",
        "Correo enviado. WhatsApp no enviado.",
      );
    } else if (!emailSent && whatsappSent) {
      this.notificationsService.growlNotify(
        "warn",
        "Notificación parcial",
        "Correo no enviado. WhatsApp enviado.",
      );
    } else {
      this.notificationsService.growlNotify(
        "error",
        "Notificación no enviada",
        "Correo no enviado. WhatsApp no enviado.",
      );
    }
  }

  public getSelectedCitationsIds(): number[] {
    const selected = this.selectCitationsTransf || [];
    return selected
      .filter(function (item) {
        return item && item.id;
      })
      .map(function (item) {
        return item.id;
      });
  }

  public cancelNotifyCustomer() {
    this.modViewDialogNotifyCitations = false;
  }

  public filterRefresh() {
    this.restartTimer();
    this.filter(true);
  }

  public filter(pageRefresh?) {
    if (pageRefresh) {
      this.page = 1;
      this.first = 0;
    }

    this.filters = [];

    this.filters.push({ key: "recruited_accepted", value: 1 });

    if (this.candidate) {
      this.filters.push({
        key: "candidate_id-in",
        value: this.candidate[0].id,
      });
    }

    if (this.company_id_filter.value) {
      if (this.company_id_filter.value.id) {
        this.filters.push({
          key: "company_id-lk",
          value: this.company_id_filter.value.id,
        });
      }
    }
    if (this.candidate_id_filter.value) {
      if (this.candidate_id_filter.value.id) {
        this.filters.push({
          key: "candidate_id-lk",
          value: this.candidate_id_filter.value.id,
        });
      }
    }
    if (this.recruited_by_id_filter.value) {
      if (this.recruited_by_id_filter.value.id) {
        this.filters.push({
          key: "recruited_by_id-lk",
          value: this.recruited_by_id_filter.value.id,
        });
      }
    }
    if (this.interviewed_by_id_filter.value) {
      if (this.interviewed_by_id_filter.value.id) {
        this.filters.push({
          key: "interviewed_by_id-lk",
          value: this.interviewed_by_id_filter.value.id,
        });
      }
    }
    if (this.documental_analysis_by_id_filter.value) {
      if (this.documental_analysis_by_id_filter.value.id) {
        this.filters.push({
          key: "documental_analysis_by_id-lk",
          value: this.documental_analysis_by_id_filter.value.id,
        });
      }
    }
    if (this.hire_by_id_filter.value) {
      if (this.hire_by_id_filter.value.id) {
        this.filters.push({
          key: "hire_by_id-lk",
          value: this.hire_by_id_filter.value.id,
        });
      }
    }
    if (this.hiring_analyst_id_filter.value) {
      if (this.hiring_analyst_id_filter.value.id) {
        this.filters.push({
          key: "hiring_analyst_id-lk",
          value: this.hiring_analyst_id_filter.value.id,
        });
      }
    }
    if (this.manager_send_hiring_sign_by_id_filter.value) {
      if (this.manager_send_hiring_sign_by_id_filter.value.id) {
        this.filters.push({
          key: "manager_send_hiring_sign_by_id-lk",
          value: this.manager_send_hiring_sign_by_id_filter.value.id,
        });
      }
    }
    if (this.venue_id_filter.value) {
      this.filters.push({
        key: "venue_id-lk",
        value: this.venue_id_filter.value,
      });
    }
    if (this.send_customer_filter.value) {
      if (this.send_customer_filter.value == "Favorable")
        this.filters.push({
          key: "result_send_customer",
          value: "Favorable,Autorizado",
        });
      else if (this.send_customer_filter.value == "null")
        this.filters.push({
          key: "result_send_customer",
          value: "No,Favorable,Autorizado",
        });
      else this.filters.push({ key: "result_send_customer", value: "" });
    }
    if (this.send_hiring_filter.value) {
      if (this.send_hiring_filter.value == "Si")
        this.filters.push({ key: "send_hiring", value: "Si" });
      else if (this.send_hiring_filter.value == "pending")
        this.filters.push({ key: "send_hiring", value: "pending" });
      else if (this.send_hiring_filter.value == "No contratado")
        this.filters.push({ key: "send_hiring", value: "No contratado" });
      else if (this.send_hiring_filter.value == "No")
        this.filters.push({
          key: "send_hiring",
          value: "No,Si,pending,No contratado",
        });
      else this.filters.push({ key: "send_hiring-in", value: "" });
    }
    if (this.send_documental_management_filter.value) {
      if (this.send_documental_management_filter.value == "1")
        this.filters.push({ key: "send_documental_management", value: "1" });
      else this.filters.push({ key: "send_documental_management", value: "0" });
    }

    if (this.send_income_order_filter.value) {
      if (this.send_income_order_filter.value == "1")
        this.filters.push({ key: "send_income_order", value: "1" });
      else this.filters.push({ key: "send_income_order", value: "0" });
    }

    if (this.citacions_sources_filter.value != "") {
      if (this.citacions_sources_filter.value == "ChatBox")
        this.filters.push({ key: "source", value: "Chatbox" });
      else
        this.filters.push({
          key: "source",
          value: "Aplicación desde portal candidatos",
        });
    }

    if (
      this.result_documental_analysis_filter.value != null &&
      this.result_documental_analysis_filter.value != "" &&
      this.result_documental_analysis_filter.value != undefined
    )
      this.filters.push({
        key: "result_documental_analysis",
        value: this.result_documental_analysis_filter.value,
      });

    if (this.status_medical_examen_filter.value.indexOf("") == "-1") {
      this.filters.push({
        key: "result_medical_exams-lk",
        value: this.status_medical_examen_filter.value,
      });
    }
    if (this.result_hired_filter.value.indexOf("") == "-1") {
      this.filters.push({
        key: "result_hire-lk",
        value: this.result_hired_filter.value,
      });
    }
    if (
      this.start_admission_date_filter.value &&
      this.end_admission_date_filter.value
    ) {
      const start_admission_date_filter = this.constDatesFilter(
        this.start_admission_date_filter.value,
        true,
        false,
      );
      const end_admission_date_filter = this.constDatesFilter(
        this.end_admission_date_filter.value,
        false,
        false,
      );
      if (start_admission_date_filter) {
        this.filters.push({
          key: "admission_date-min",
          value: start_admission_date_filter,
        });
      }

      if (end_admission_date_filter) {
        this.filters.push({
          key: "admission_date-max",
          value: end_admission_date_filter,
        });
      }
    }

    if (
      this.start_date_send_doc_man_filter.value &&
      this.end_date_send_doc_man_filter.value
    ) {
      const start_date_send_doc_man_filter = this.constDatesFilter(
        this.start_date_send_doc_man_filter.value,
        true,
        false,
      );
      const end_date_send_doc_man_filter = this.constDatesFilter(
        this.end_date_send_doc_man_filter.value,
        false,
        false,
      );
      if (start_date_send_doc_man_filter)
        this.filters.push({
          key: "start_send_documental_management-min",
          value: start_date_send_doc_man_filter,
        });

      if (end_date_send_doc_man_filter)
        this.filters.push({
          key: "start_send_documental_management-max",
          value: end_date_send_doc_man_filter,
        });
    }

    if (
      this.start_date_medical_appointment_filter.value &&
      this.end_date_medical_appointment_filter.value
    ) {
      const start_date_medical_appointment_filter = this.constDatesFilter(
        this.start_date_medical_appointment_filter.value,
        true,
        true,
      );
      const end_date_medical_appointment_filter = this.constDatesFilter(
        this.end_date_medical_appointment_filter.value,
        false,
        true,
      );
      if (start_date_medical_appointment_filter) {
        this.filters.push({
          key: "date_medical_appointment-min",
          value: start_date_medical_appointment_filter,
        });
      }

      if (end_date_medical_appointment_filter) {
        this.filters.push({
          key: "date_medical_appointment-max",
          value: end_date_medical_appointment_filter,
        });
      }
    }
    if (
      this.start_suggested_date_medical_exam_filter.value &&
      this.end_suggested_date_medical_exam_filter.value
    ) {
      const start_suggested_date_medical_exam_filter = this.constDatesFilter(
        this.start_suggested_date_medical_exam_filter.value,
        true,
        true,
      );
      const end_suggested_date_medical_exam_filter = this.constDatesFilter(
        this.end_suggested_date_medical_exam_filter.value,
        false,
        true,
      );
      if (start_suggested_date_medical_exam_filter) {
        this.filters.push({
          key: "suggested_date_medical_exam-min",
          value: start_suggested_date_medical_exam_filter,
        });
      }

      if (end_suggested_date_medical_exam_filter) {
        this.filters.push({
          key: "suggested_date_medical_exam-max",
          value: end_suggested_date_medical_exam_filter,
        });
      }
    }

    if (this.sortHireToday && !this.only_attended) {
      this.sort = "-citations.start_send_hiring_sign";
      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);
      this.filters.push({
        key: "start_send_hiring_sign-min",
        value: formatDate(today.toISOString()),
      });
      this.filters.push({ key: "send_hiring_sign-lk", value: 1 });
      this.per_page = 10;
    } else {
      this.per_page = 10;
      if (this.send_hiring_sign_filter.value) {
        this.filters.push({
          key: "send_hiring_sign-lk",
          value: this.send_hiring_sign_filter.value,
        });
      }
    }

    if (this.sortHire && !this.only_attended) {
      this.sort = "-citations.start_send_hiring_sign";
      this.filters.push({ key: "send_hiring_sign-lk", value: 1 });
    }

    if (this.hasRole(27) || this.hasRole(28) || this.hasRole(74))
      this.sort = "-citations.start_send_documental_management";

    if (this.params_id_requisition) {
      this.getCitationsByRequisitions(this.params_id_requisition);
    } else {
      this.getCitations();
    }
  }

  public activeAttendance(citation: Attendance, value?) {
    if (value === "0") {
      citation.attended_at = null;
    } else {
      citation.attended_at = formatDate(new Date().toISOString());
    }
    citation.attended = value;
    this.putAttendance(citation);
  }

  public sendDocumentalmanagementAttendance(citation_sel: Attendance, value?) {
    let citation: any = {};
    citation.id = citation_sel.id;
    citation.send_documental_management = value;
    if (value === "0") {
      citation.start_send_documental_management = null;
      citation.send_doc_man_obs = null;
      Object.assign(citation_sel, citation);
      this.sendDocumentalManDialog = false;
      this.putAttendance(citation);
    } else {
      citation.start_send_documental_management = formatDate(
        new Date().toISOString(),
      );
      Object.assign(citation_sel, citation);
      this.selectCitation = citation;
      this.sendDocumentalManDialog = true;
    }
  }

  public saveSendDocumentalManagementAttendance(values) {
    this.selectCitation.send_doc_man_obs = values.send_doc_man_obs;
    this.putAttendance(this.selectCitation);
    this.form9.reset();
    this.selectCitation = null;
    this.sendDocumentalManDialog = false;
  }

  public cancelSendDocumentalManagementAttendance() {
    this.sendDocumentalManDialog = false;
    this.selectCitation = null;
  }

  public sendIncomeOrderAttendance(citation: Attendance, value?) {
    if (value === "0") {
      citation.start_send_income_order = null;
    } else {
      citation.start_send_income_order = formatDate(new Date().toISOString());
    }
    citation.send_income_order = value;
    this.putAttendance(citation);
  }

  public sendHiringSignAttendance(citation_sel: Attendance, value?) {
    let citation: any = {};
    citation.id = citation_sel.id;
    citation.send_hiring_sign = value;
    if (value === "0") {
      citation.start_send_hiring_sign = null;
      citation.manager_send_hiring_sign_by_id = null;
    } else {
      citation.start_send_hiring_sign = formatDate(new Date().toISOString());
      citation.manager_send_hiring_sign_by_id =
        citation_sel.manager_send_hiring_sign_by_id;
    }
    Object.assign(citation_sel, citation);
    this.putAttendance(citation);
  }
  public employeeSendHiringSignAttendance(value) {
    console.log("El nombre es: ");
    console.log(value);
    if (value.id) {
      console.log("El nombre..  ");
      this.selectCitation.manager_send_hiring_sign_by_id = value.id;
      //habilitar el botón de guardar
    }
  }
  public saveSendHiringSignAttendance(values) {
    this.selectCitation.manager_send_hiring_sign_by_id =
      values.manager_send_hiring_sign_by_id.id;
    this.sendHiringSignAttendance(this.selectCitation, "1");
    this.selectCitation = null;
    this.gestSignHireDialog = false;
  }

  public cancelSendHiringSignAttendance() {
    this.employeeSelected = null;
    this.gestSignHireDialog = false;
    this.selectCitation = null;
  }

  public sendHiringAttendance(citation_sel: Attendance, value?) {
    let citation: any = {};
    citation.id = citation_sel.id;
    if (value === "No") {
      citation.start_send_hiring = null;
    } else {
      citation.start_send_hiring = formatDate(new Date().toISOString());
    }
    citation.send_hiring = value;
    Object.assign(citation_sel, citation);
    this.putAttendance(citation);
  }

  public comeMedicalExamsAttendance(citation: Attendance, value?) {
    if (value === "0") {
      citation.date_come_medical_exams = null;
    } else {
      citation.date_come_medical_exams = formatDate(new Date().toISOString());
    }
    citation.come_medical_exams = value;
    this.putAttendance(citation);
  }

  public recruitAttendance(citation: Attendance) {
    if (!citation.recruited_accepted) {
      citation.recruited_accepted_at = null;
    } else {
      citation.recruited_accepted_at = formatDate(new Date().toISOString());
    }

    this.putAttendance(citation);
  }
  public saveMedicalExamsAttendance(
    citation: Attendance,
    date_medical_appointment: string,
    lab_medical_exams: string,
  ) {
    citation.date_medical_appointment = formatDate(
      new Date(date_medical_appointment).toISOString(),
    );
    citation.lab_medical_exams = lab_medical_exams;
    citation.start_medical_exams = formatDate(new Date().toISOString());
    this.putAttendance(citation);
    this.selectCitation = null;
    this.date_medical_appointment.setValue("");
    this.lab_medical_exams.setValue("");
    this.getMedicalAppointmentLaboratoryDialog = false;
  }

  public putAttendance(
    values: Attendance,
    citation_original: Attendance = null,
    isForceRetry: boolean = false,
  ) {
    if (values.recruited_at)
      values.recruited_at = formatDate(values.recruited_at);

    if (values) {
      const promise = this.citationService.updateCitation(values.id, values);
      this.promiseForm = promise.toPromise().then(
        (response) => {
          if (citation_original != null) {
            let response_data = response.json();
            Object.assign(citation_original, response_data);
          }
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
        },
        (error) => {
          let parsedBody: any = null;
          try {
            parsedBody = error && error._body ? JSON.parse(error._body) : null;
          } catch (e) {
            parsedBody = null;
          }

          if (
            !isForceRetry &&
            parsedBody &&
            parsedBody.status === "confirmation_required" &&
            parsedBody.requires_confirmation === true &&
            String((values as any).send_documental_management) === "1"
          ) {
            const message =
              parsedBody.message ||
              "El candidato tiene una exclusión. ¿Desea continuar?";

            if (window.confirm(message)) {
              const retryValues: any = {
                ...values,
                force_exclusion_process: 1,
              };
              this.putAttendance(retryValues, citation_original, true);
            }
            return;
          }

          this.loading = false;
          if (parsedBody && parsedBody.message) {
            this.notificationsService.growlNotify("error", parsedBody.message);
            return;
          }

          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg,
                  );
                });
            });
        },
      );
    }
  }

  public showDocumentation(citation) {}

  public showResultNewCandidate(msg) {
    this.msgs = [];
    this.msgs.push(msg);
  }

  public listView() {
    this.viewType = "list";
  }

  public kanbanView() {
    if (this.params_id_requisition) {
      this.getCitationsByRequisitions(this.params_id_requisition);
    } else {
      this.getCitations();
    }

    this.viewType = "kanban";
  }

  public showEditCitation(citation: Attendance, type: string, event: string) {
    clearInterval(this.reloadInterval);
    this.idEditRequisition = citation.requisition_id;
    this.idEditCitation = citation.id;
    this.citationEditCitation = citation;
    this.statusEditCitation = status;
    this.typeEditCitation = type;
    this.selectCitation = citation;

    //----Para enviado a examenes medicos (enviado orden ingreso)
    if (
      type == "income_order" &&
      (citation.send_income_order == false ||
        citation.send_income_order == null)
    ) {
      this.selectCitation.send_income_order = true;
      this.selectCitation.start_send_income_order = formatDate(
        new Date().toISOString(),
      );
    }

    if (event == "end") {
      this.modViewDialog = true;
      this.editEventPart = event;
    }

    if (event == "hiring_analyst") {
      this.editEventPart = event;
      this.modViewDialog = true;
    }

    if (event === "start") {
      this.sendCitationParam(citation, type);
    }

    if (event === "hunterxValidation") {
      this.hunterxValidation(citation, type);
      this.editEventPart = event;
    }
  }

  public hunterxValidation(values, type) {
    this.loading = true;

    const promise = this.citationService.validationDocumentalHunterx(values.id);
    this.promiseForm = promise.toPromise().then(
      (response) => {
        this.loading = false;
        let response_data = response.json();

        this.resultHunterxValidation(response_data.data, values, type);

        this.notificationsService.growlNotify("success", response_data.message);
      },
      (error) => {
        this.loading = false;
        console.error("Error en validación HunterX:", error);

        let errorMessage = "Error al realizar la validación";
        try {
          const errorBody = JSON.parse(error._body);
          errorMessage = errorBody.message || errorMessage;
        } catch (e) {}
        this.notificationsService.growlNotify("error", errorMessage);
      },
    );
  }

  public resultHunterxValidation(data, citation, type) {
    let withoutStrangeness = 0;
    let withStrangeness = 0;
    let itemswithStrangeness = [];

    data.forEach((item) => {
      if (item.detail === "SIN HALLAZGOS" || item.category === 4) {
        withoutStrangeness++;
      } else {
        withStrangeness++;
        itemswithStrangeness.push({
          source: item.source,
          detail: item.detail,
          category: item.category,
          files: item.files,
        });
      }
    });

    let citationUpdate: any = {
      id: citation.id,
    };

    if (withStrangeness > 0) {
      citationUpdate.result_background_validation = "Novedad";
      citationUpdate.observation_background_validation =
        "Se encontraron " +
        withStrangeness +
        " novedad(es) en la validación de antecedentes.";
    } else {
      citationUpdate.result_background_validation = "Favorable";
      citationUpdate.observation_background_validation =
        "No se encontraron novedades en la validación de antecedentes.";
    }

    citationUpdate.end_background_validation = formatDate(
      new Date().toISOString(),
    );

    this.putAttendance(citationUpdate, citation);
  }

  public sendCitationParam(values, type) {
    let citation: any = {};
    citation.id = values.id;

    switch (type) {
      case "interview":
        citation.start_interview = formatDate(new Date().toISOString());
        if (this.hasPermission("get citation allinone")) {
          citation.start_send_customer = formatDate(new Date().toISOString());
          citation.start_documental_analysis = formatDate(
            new Date().toISOString(),
          );
          citation.start_referencing = formatDate(new Date().toISOString());
          citation.start_test = formatDate(new Date().toISOString());
          citation.start_send_hiring = formatDate(new Date().toISOString());
          citation.start_send_hiring_sign = formatDate(
            new Date().toISOString(),
          );
          citation.start_send_income_order = formatDate(
            new Date().toISOString(),
          );
          citation.start_send_documental_management = formatDate(
            new Date().toISOString(),
          );
        }
        break;
      case "send_customer":
        citation.start_send_customer = formatDate(new Date().toISOString());
        break;
      case "documental_analysis":
        citation.start_documental_analysis = formatDate(
          new Date().toISOString(),
        );
        break;
      case "referencing":
        citation.start_referencing = formatDate(new Date().toISOString());
        break;
      case "background_validation":
        citation.start_background_validation = formatDate(
          new Date().toISOString(),
        );
        break;
      case "test":
        citation.start_test = formatDate(new Date().toISOString());
        break;
      case "medical_exams":
        citation.start_medical_exams = formatDate(new Date().toISOString());
        break;
      case "hire":
        citation.start_hire = formatDate(new Date().toISOString());
        break;
      default:
        citation.id = undefined;
        break;
    }

    Object.assign(values, citation);
    this.putAttendance(citation, values);
  }

  public hiddenEditCitation() {
    if (this.params_id_requisition) {
      this.getCitationsByRequisitions(this.params_id_requisition);
    } else {
      this.getCitations();
    }
    this.restartTimer();
    this.modViewDialog = false;
  }
  public onDialogHide() {
    this.hiddenEditCitation();
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }
  public hasRole(rol) {
    var r: boolean = false;
    var role = this.role_id;
    if (role == rol) {
      r = true;
    }
    return r;
  }
  public viewDialogCandidate(candidate: Candidate, sticky: boolean) {
    this.selectCandidate = candidate;
    this.modViewDialogCandidate = true;
    this.sticky = sticky;
  }
  public viewDialogWhatsapp(candidate: Candidate, sticky: boolean) {
    this.selectCandidate = candidate;
    this.mobile_send.setValue(this.selectCandidate.mobile);
    this.message_send.setValue("Hola estimado(a) " + this.selectCandidate.name);
    this.modViewDialogWhatsapp = true;
    this.sticky = sticky;
  }

  public viewHideDialogCandidate() {
    if (!this.sticky) {
      this.modViewDialogCandidate = false;
    }
  }

  public cancelCandidate(res) {
    this.selectCandidate = null;
    this.modViewDialogCandidate = false;
  }

  public filterGeneral() {
    this.sortHireToday = false;
    this.sortHire = false;
    this.page = 1;
    this.first = 0;
    this.filter(true);
    this.restartTimer();
  }

  public filterSortHireToday() {
    this.sortHireToday = true;
    this.sortHire = false;
    this.page = 1;
    this.first = 0;
    this.filter(true);
    this.restartTimer();
  }

  public filterSortHireAll() {
    this.sortHireToday = false;
    this.sortHire = true;
    this.page = 1;
    this.first = 0;
    this.filter(true);
    this.restartTimer();
  }

  public showExportDialog() {
    this.modExportDialog = true;
  }

  public cancelExport() {
    this.modExportDialog = false;
  }

  public showDaviviendaExportDialog() {
    this.modDaviviendaExportDialog = true;
  }

  public cancelTransfer() {
    this.restartTimer();
    this.modViewDialogExchangeCitation = false;
    this.requisitionTrasnferOk = false;
    this.requisitionTrasnfer = [];
    this.resultSelectCitationsTransf = [];
    this.lengthresultSelectCitationsTransf = 0;
    this.showrequisitionTransfer = false;
  }

  public showRecruitmentDialog() {
    this.modRecruitmentDialog = true;
  }

  public cancelRecruitment() {
    this.modRecruitmentDialog = false;
    this.reloadInterval();
  }

  public showImportDialog() {
    this.modImportDialog = true;
  }

  public cancelImport() {
    this.modImportDialog = false;
  }

  public showDocumentationDialog(citation, type) {
    this.selectCitation = citation;
    this.uploadedAttachment = [];
    this.selectCitationType = type;
    var citation_id = citation.id;
    var profile_survey_id = citation.requisition.profile_survey_id;

    this.contractService
      .getDocumentProfileSurveyUnionCheckList(
        citation_id,
        profile_survey_id,
        this.selectCitationType,
      )
      .toPromise()
      .then(
        (response) => {
          this.listDocuments = [];
          this.result = response.json();
          console.log("tipo : " + typeof this.result);
          let list = [...this.listDocuments];
          this.result.data.forEach((element) => {
            if (element.document_profile_survey.length > 0) {
              for (var x = 0; x < element.document_profile_survey.length; x++) {
                if (element.document_profile_survey[x].expires_at)
                  element.document_profile_survey[x].expires_at = new Date(
                    element.document_profile_survey[x].expires_at,
                  );
              }
            }
            if (element.type == type) {
              list.push(element);
            }
          });
          this.listDocuments = list;
          this.modViewDialogDocumentation = true;
          clearInterval(this.reloadInterval);
          this.loading_upload = false;
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        },
      );

    if (this.modViewDialogDocumentation == false)
      this.getDocumentHV(citation.candidate_id);
  }

  public cancelDocumentation() {
    this.selectCitation = undefined;
    this.modViewDialogDocumentation = false;
  }

  public onUploadImportFile(event: any) {
    this.uploadedImportFile = [];
    for (const file of event.srcElement.files) {
      this.uploadedImportFile.push(file);
    }
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        this.prewiewImportFile = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public updateImportFile(event: any) {
    this.translate.get("uploading").subscribe((res: string) => {
      this.notificationsService.growlNotify("info", res + "...");
    });

    this.uploadedImportFile = [];
    for (const file of event.files) {
      this.uploadedImportFile.push(file);
    }

    this.promiseImportFile = this.uploadFilesService
      .updateFileImportCitation(this.uploadedImportFile)
      .toPromise()
      .then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg,
                  );
                });
            });
        },
      );
  }

  public exportReportExcel(values) {
    let d = new Date(values.f4_date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    const f4_date_start = formatDate(d);

    d = new Date(values.f4_date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);
    const f4_date_end = formatDate(d);

    let url =
      this.apiUrl +
      "/citations/excel?" +
      "token=" +
      localStorage.getItem("token") +
      "&_page=1&_limit=100000&_sort=venue_id,company_id&";

    if (values.f4_venue_id) {
      url = url + "venue_id-in=" + values.f4_venue_id + "&";
    }

    if (values.f4_company_id) {
      url = url + "company_id-in=" + values.f4_company_id.id + "&";
    }

    if (values.f4_status_filter !== "all" && values.f4_status_filter !== "") {
      url = url + "status-in=" + values.f4_status_filter + "&";
    }

    if (values.f4_export_type_filter) {
      url = url + "type=" + values.f4_export_type_filter.value + "&";
    }

    if (values.f4_status_hiring) {
      url = url + "result-hire=" + values.f4_status_hiring + "&";
    }

    if (values.f4_export_type_filter) {
      if (
        values.f4_export_type_filter.value ===
        "Reporte Citación - Contratado Diario"
      ) {
        if (f4_date_start) {
          url = url + "end_hire-min=" + f4_date_start + "&";
        }

        if (f4_date_end) {
          url = url + "end_hire-max=" + f4_date_end + "&";
        }
      } else if (
        values.f4_export_type_filter.value ===
          "Reporte Citación - Documentación" ||
        values.f4_export_type_filter.value ===
          "Reporte Citación - Contratado por Fecha Ingreso" ||
        values.f4_export_type_filter.value ===
          "Reporte Citación - Fecha de ingreso"
      ) {
        if (f4_date_start) {
          url = url + "admission_date-min=" + f4_date_start + "&";
        }

        if (f4_date_end) {
          url = url + "admission_date-max=" + f4_date_end + "&";
        }
      } else {
        if (f4_date_start) {
          url = url + "created_at-min=" + f4_date_start + "&";
        }

        if (f4_date_end) {
          url = url + "created_at-max=" + f4_date_end + "&";
        }
        if (
          values.f4_export_type_filter.value ===
          "Reporte Citación - Reclutamiento"
        ) {
          url =
            url + "recruited=1&_with=small_requisition,small_profile_survey&";
        }
      }
    } else {
      if (f4_date_start) {
        url = url + "created_at-min=" + f4_date_start + "&";
      }

      if (f4_date_end) {
        url = url + "created_at-max=" + f4_date_end + "&";
      }
    }

    window.open(url, "_blank");
  }

  public exportDaviviendaReportExcel(values) {
    let d = new Date(values.form_date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    values.form_date_start = formatDate(d);
    d = new Date(values.form_date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);

    values.form_date_end = formatDate(d);

    let url =
      this.apiUrl +
      "/citations/davivienda/excel?" +
      "token=" +
      localStorage.getItem("token") +
      "&_page=1&_limit=100000&_sort=start_medical_exams&";

    if (values.form_export_type)
      url = url + "type=" + values.form_export_type.value + "&";

    if (values.form_date_start)
      url = url + "start_medical_exams-min=" + values.form_date_start + "&";

    if (values.form_date_end)
      url = url + "start_medical_exams-max=" + values.form_date_end + "&";

    window.open(url, "_blank");
  }

  getCandidate(query?: string) {
    this.candidateService
      .getCandidate(this.page, this.per_page, undefined, query)
      .toPromise()
      .then(
        (response) => {
          this.candidate = response.json().data;
          if (
            response.json().meta.total > response.json().meta.total_filtered
          ) {
            this.totalRecords = response.json().meta.total_filtered;
          } else {
            this.totalRecords = response.json().meta.total;
          }
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg,
                  );
                });
            });
        },
      );
  }

  public onUploadFileDocumentProfileSurvey(event: any, citation, item) {
    console.log(event);
    for (const file of event.srcElement.files) {
      this.uploadedAttachment[item.id] = file;
    }
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        this.prewiewFileAttachment[item.id] = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public updateAttachmentDocumentProfileSurvey(
    event,
    citation,
    checklist_profile_survey,
  ) {
    this.loading_upload = true;
    this.translate.get("uploading").subscribe((res: string) => {
      this.notificationsService.growlNotify("info", res + "...");
    });

    let id;
    if (checklist_profile_survey.document_profile_survey) {
      if (checklist_profile_survey.document_profile_survey.length > 0) {
        id = checklist_profile_survey.document_profile_survey[0].id;
      }
    }

    let uploadedAttachment = [];
    for (const file of event.files) {
      uploadedAttachment.push(file);
    }

    this.promiseAttachment = this.uploadFilesService
      .updateAttachmentDocumentProfileSurvey(
        uploadedAttachment,
        id,
        citation.id,
        citation.requisition.profile_survey_id,
        checklist_profile_survey.id,
        checklist_profile_survey.list_doc_profile_survey_id,
      )
      .toPromise()
      .then(
        (response) => {
          this.uploadedAttachment[response.json().checklist_profile_survey_id] =
            { name: "Archivo Adjunto  ", id: response.json().id };
          this.translate.get("saved").subscribe((res: string) => {
            this.notificationsService.growlNotify("success", res);
            this.showDocumentationDialog(
              this.selectCitation,
              this.selectCitationType,
            );
          });
        },
        (error) => {
          this.loading_upload = false;
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg,
                  );
                });
            });
        },
      );
  }

  public deleteAttachmentDocumentProfileSurvey(id) {
    this.promiseAttachment = this.uploadFilesService
      .deleteAttachmentDocumentProfileSurvey(id)
      .toPromise()
      .then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.notificationsService.growlNotify("success", res);
            this.showDocumentationDialog(
              this.selectCitation,
              this.selectCitationType,
            );
          });
          const index = this.findElement(this.uploadedAttachment, id);
          if (index > -1) {
            this.uploadedAttachment.splice(index, 1);
          }
          console.log(this.uploadedAttachment);
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg,
                  );
                });
            });
        },
      );
  }

  public gotoAttachment(id) {
    window.open(
      this.apiUrl +
        "/list-document-profile-surveis/" +
        id +
        "/attachment" +
        "?token=" +
        localStorage.getItem("token"),
      "_blank",
    );
  }

  public gotoAttachmentDocumentProfileSurvey(id) {
    window.open(
      this.apiUrl +
        "/document-profile-surveis/" +
        id +
        "/attachment" +
        "?token=" +
        localStorage.getItem("token"),
      "_blank",
    );
  }

  public downloadAllFiles(id) {
    window.open(
      this.apiUrl +
        "/document-profile-surveis/" +
        id +
        "/zip" +
        "?token=" +
        localStorage.getItem("token"),
      "_blank",
    );
  }

  printCitation(citation) {
    window.open(
      this.apiUrl +
        "/citations/" +
        citation.id +
        "/pdf?token=" +
        localStorage.getItem("token"),
      "_blank",
    );
  }

  public findElement(list, search) {
    let find = -1;
    let itera = 0;
    list.forEach((element) => {
      if (element.id === search) {
        find = itera;
      }
      itera++;
    });
    return find;
  }

  percentDocContract(citation) {
    let percent = 0;
    let totalContract = 0;
    let totalContractUpload = 0;
    let docsUpload = citation.document_profile_survey;
    let docsChecklist =
      citation.requisition.profile_survey_small.checklist_profile_survey;
    docsChecklist.forEach((element2) => {
      let docrepet = false;
      docsUpload.forEach((element) => {
        if (element.list_profile_survey_id == element2.list_id && !docrepet) {
          totalContractUpload = totalContractUpload + 1;
          docrepet = true;
        }
      });
    });
    totalContract = docsChecklist.length;
    percent = Math.floor((totalContractUpload * 100) / totalContract);
    return percent;
  }

  public findListDocumentProfileSurvey(list, search) {
    let find = -1;
    let itera = 0;
    list.forEach((element) => {
      if (element.list_profile_survey_id === search) {
        find = itera;
      }
      itera++;
    });
    return find;
  }

  openWhatsapp(event) {
    window.open(
      "https://api.whatsapp.com/send?phone=" +
        "57" +
        event.mobile_send +
        "&text=" +
        event.message_send,
      "_blank",
    );
  }

  showSidebarJustification(citation) {
    this.selectCitation = citation;
    this.getCitationJustification(this.selectCitation.id);
    this.getDataCustomerGuide(Number(this.selectCitation.company_id));
    this.displaySidebarJustification = true;
  }

  closeSidebarJustification() {
    this.form2.reset();
    this.form8.reset();
    this.selectCitation = undefined;
    this.displaySidebarJustification = false;
  }
  public newCitationJustification(values) {
    const param = {
      justification: values.justification,
      citation_id: this.selectCitation.id,
    };
    if (values) {
      const promise =
        this.attendanceJustificationService.newAttendanceJustification(
          this.selectCitation.id,
          param,
        );

      this.promiseForm = promise.toPromise().then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
          this.filter();
          this.restartTimer();
          this.closeSidebarJustification();
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "Error" });
        },
      );
    }
  }
  public editFirstDayCitation(values) {
    let id = this.selectCitation.id;
    const param = {
      first_day_instruction: values.instruction,
    };
    if (values) {
      const promise = this.citationService.updateCitation(id, param);

      this.promiseForm = promise.toPromise().then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
          this.filter();
          this.restartTimer();
          this.closeSidebarJustification();
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "Error" });
        },
      );
    }
  }

  getCitationJustification(id: number) {
    this.attendanceJustificationService
      .getAttendanceJustificationAll(id)
      .toPromise()
      .then(
        (response) => {
          this.listCitationJustification = response.json().data;
          this.form2.reset();
          this.form8.reset();
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        },
      );
  }
  getDataCustomerGuide(company_id: number) {
    this.customerGuideService
      .infoCustomerGuideCitation(company_id)
      .toPromise()
      .then(
        (response) => {
          this.informationCustomerGuide = response.json();
          this.form8.reset();
          this.form2.reset();
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        },
      );
  }
  onRowSelect(event) {
    console.log(this.selectCitationsTransf);
    this.updateSelectionFlags();
  }

  onRowUnselect(event) {
    console.log(this.selectCitationsTransf);
    this.updateSelectionFlags();
  }

  onHeaderCheckboxToggle(event) {
    this.updateSelectionFlags();
  }

  exchangeCitationsShowDialog() {
    clearInterval(this.reloadInterval);
    this.modViewDialogExchangeCitation = true;
  }

  notifyCitationsShowDialog() {
    clearInterval(this.reloadInterval);
    this.modViewDialogNotifyCitations = true;
  }

  approveCitationsShowDialog() {
    clearInterval(this.reloadInterval);
    this.modViewDialogApproveCitations = true;
    this.approveCitationsForm.reset();
  }

  private updateSelectionFlags(): void {
    const selected = this.selectCitationsTransf || [];
    const count = selected.length;

    this.showbuttonExchangeCitation = count > 0;

    if (count === 0) {
      this.showbuttonNotifyApproveCitations = false;
      return;
    }

    const hasInvalidIncomeOrder = selected.some(function (item) {
      return (
        !item ||
        item.start_send_income_order === null ||
        item.start_send_income_order === undefined
      );
    });

    if (hasInvalidIncomeOrder) {
      this.showbuttonNotifyApproveCitations = false;
      return;
    }

    if (count === 1) {
      this.showbuttonNotifyApproveCitations = true;
      return;
    }

    const firstCompanyId = selected[0] ? selected[0].company_id : null;

    this.showbuttonNotifyApproveCitations = selected.every(function (item) {
      return item && item.company_id === firstCompanyId;
    });
  }

  public getRequisitionTransfer(requisition_id) {
    //let requisition_id;
    if (requisition_id) {
      this.loadingShowTransfReq = true;
      this.citationService
        .infoRequisition(requisition_id)
        .toPromise()
        .then(
          (response) => {
            this.loadingShowTransfReq = false;
            this.showrequisitionTransfer = true;
            this.requisitionTrasnfer = response.json().data;
            if (
              this.requisitionTrasnfer[0].status != "Abierto" &&
              this.requisitionTrasnfer[0].status != "En Proceso" &&
              this.requisitionTrasnfer[0].status != "Backup"
            ) {
              this.showrequisitionTransferClose = true;
              this.requisitionTrasnferOk = false;
            } else {
              this.requisitionTrasnferOk = true;
              this.showrequisitionTransferClose = false;
            }
          },
          (error) => {
            this.loadingShowTransfReq = false;
            this.requisitionTrasnferOk = false;
            this.showrequisitionTransfer = false;
            this.showrequisitionTransferClose = false;
          },
        );
    }
  }

  public getStatusRadioButton(formValue, nameValue: any) {
    var status = false;
    if (formValue) {
      if (formValue == nameValue) status = true;
    }
    return status;
  }

  public getRequiredMassiveAuthorization(value: any) {
    if (value == "4")
      this.approveCitationsForm
        .get("authorization_observations")
        .setValidators([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(500),
        ]);
    else
      this.approveCitationsForm
        .get("authorization_observations")
        .setValidators([]);

    this.approveCitationsForm
      .get("authorization_observations")
      .updateValueAndValidity();
  }

  public cancelApproveCitations() {
    this.modViewDialogApproveCitations = false;
    this.approveCitationsForm.reset();
  }

  public saveApproveCitations(values) {
    const selected = this.selectCitationsTransf || [];

    if (!values || selected.length === 0) {
      this.msgs.push({
        severity: "warn",
        summary: "Seleccione al menos una citación",
      });
      return;
    }

    const approvals = selected.map((item) => {
      const isAuthorized =
        values.customer_approved_id == "2" ||
        values.customer_approved_id == "4";

      return {
        citation_id: item.id,
        code: values.customer_approved_id,
        authorized: isAuthorized,
        authorization_observations:
          values.customer_approved_id == "4"
            ? values.authorization_observations
            : null,
      };
    });

    const payload = { approvals: approvals };

    const promise =
      this.citationService.massiveIncomeOrderAuthorization(payload);

    this.promiseForm = promise.toPromise().then(
      (response) => {
        this.notificationsService.growlNotify(
          "success",
          "Autorización enviada",
        );
        this.modViewDialogApproveCitations = false;
        this.approveCitationsForm.reset();
        this.filterRefresh();
      },
      (error) => {
        this.msgs.push({ severity: "error", summary: "Error" });
      },
    );
  }

  public RequisitionsTransfer(values) {
    var selectCitationsTransfId = [];
    if (this.requisitionTrasnferOk) {
      for (let i = 0; i < this.selectCitationsTransf.length; i++)
        selectCitationsTransfId.push(this.selectCitationsTransf[i].id);

      console.log(
        "El Id de la requisición es:" +
          this.requisitionTrasnfer[0].id +
          " y las operaciones son: " +
          selectCitationsTransfId,
      );
      console.log(JSON.stringify(selectCitationsTransfId));
      let param = {
        citationsTransfer: selectCitationsTransfId,
        profileSurveyRequisition: this.requisitionTrasnfer[0].profile_survey_id,
        companyRequisition: this.requisitionTrasnfer[0].company_id,
      };
      if (selectCitationsTransfId.length > 0) {
        this.citationService
          .citationsTransferService(this.requisitionTrasnfer[0].id, param)
          .toPromise()
          .then(
            (response) => {
              // this.showrequisitionTransfer=true;
              this.resultSelectCitationsTransf = response.json().data;
              this.lengthresultSelectCitationsTransf =
                this.resultSelectCitationsTransf.length;
              console.log("Listo!!");
            },
            (error) => {
              // this.showrequisitionTransfer=false;
              alert("Error");
              this.lengthresultSelectCitationsTransf = 0;
            },
          );
      } else {
        alert("Citacion(es) ya está(n) agregada(a) a la requisición");
        console.log("Citaciones no validas para anexar");
      }
    }
  }
  public showUploadDialog() {
    this.modViewDialogUploadCitationExc = true;
    clearInterval(this.reloadInterval);
  }

  public cancelUpload() {
    this.modViewDialogUploadCitationExc = false;
    this.requisitionTrasnferOk = false;
    this.requisitionTrasnfer = [];
    this.resultSelectCitationsTransf = [];
    this.lengthresultSelectCitationsTransf = 0;
    this.showrequisitionTransfer = false;
    this.restartTimer();
  }
  public attachmentUploadCitations(event) {
    this.loading_upload = true;
    this.translate.get("uploading").subscribe((res: string) => {
      this.notificationsService.growlNotify("info", res + "...");
    });

    let uploadedAttachment = [];
    for (const file of event.files) {
      uploadedAttachment.push(file);
    }

    this.promiseAttachment = this.uploadFilesService
      .attachmentUploadCitations(uploadedAttachment)
      .toPromise()
      .then(
        (response) => {
          this.loading_upload = false;
          this.citationsUploadResult = response.json().data;
          this.citationsUploadResultStatus = response.status;
          this.lengthCitationsUploadResult = this.citationsUploadResult.length;
          console.log("Documento subido excel");
          this.translate.get("saved").subscribe((res: string) => {
            this.notificationsService.growlNotify("success", res);
          });
        },
        (error) => {
          this.loading_upload = false;
          let msg = "";
          this.citationsUploadResult = error._body;
          this.citationsUploadResultStatus = error.status;
          this.lengthCitationsUploadResult = 0;
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg,
                  );
                });
            });
        },
      );
  }
  public downloadTemplateCitations() {
    window.open(
      this.apiUrl +
        "/document-profile-surveis/downloadTemplateCitations" +
        "?token=" +
        localStorage.getItem("token"),
    );
  }

  getDocumentHV(id) {
    this.listDocumentsHV = [];
    this.candidateService
      .getDocumentsCandidateEmployee(id)
      .toPromise()
      .then(
        (response) => {
          console.log(response);
          this.listDocumentsHV = response.json();
        },
        (error) => {
          console.log(error);
        },
      );
  }
  goUrl(url) {
    window.location.href = url;
  }

  public itemsforCopy() {
    var files = new Array();
    this.listDocumentsHV.forEach((element) => {
      if (element.documents_candidate.length > 0) {
        for (var x = 0; x < element.documents_candidate.length; x++)
          files.push(element.documents_candidate[x]);
      }
    });
    return files;
  }
  downloadAllFilesHV(citation_id, profile_survey_id, dataHvJs) {
    this.copyHV = true;
    var dataHv = new Array();
    if (dataHvJs == undefined) dataHv = this.itemsforCopy();
    else dataHv.push(dataHvJs);
    let param = {
      citation_id: citation_id,
      profile_survey_id: profile_survey_id,
      data: dataHv,
    };
    this.translate.get("Copying ...").subscribe((res: string) => {
      this.notificationsService.growlNotify("info", res);
    });
    this.citationService
      .docsFromHVtoLucianaService(param)
      .toPromise()
      .then(
        (response) => {
          console.log(response);
          let msg = JSON.stringify(response);
          this.translate
            .get((<any>response)._body)
            .subscribe((res1: string) => {
              this.notificationsService.growlNotify("success", res1);
            });
          this.showDocumentationDialog(
            this.selectCitation,
            this.selectCitationType,
          );
          this.copyHV = false;
        },
        (error) => {
          this.copyHV = false;
          console.log(error);
          this.translate
            .get(JSON.parse(error._body))
            .subscribe((res: string) => {
              this.notificationsService.growlNotify("error", res);
            });
        },
      );
  }
  changesendHiringSignAttendance(citation_sel: Attendance, value?) {
    this.gestSignHireDialog = true;
    this.selectCitation = citation_sel;
  }

  public cancelmedicalAppointmentLaboratoryAttendance() {
    this.date_medical_appointment.setValue("");
    this.lab_medical_exams.setValue("");
    this.getMedicalAppointmentLaboratoryDialog = false;
    this.selectCitation = null;
  }
  constDatesFilter(dateFilter: any, zero: boolean, gmt: boolean) {
    let d = new Date(dateFilter);
    if (zero) {
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
    } else {
      d.setHours(23);
      d.setMinutes(59);
      d.setSeconds(59);
      d.setMilliseconds(59);
    }
    if (gmt) return d.toISOString();
    return formatDate(d);
  }
  getDiffColumn(value, value2) {
    if (value == "" || value == null || value2 == "" || value2 == null)
      return "";
    let dateStart = new Date(value);
    let dateEnd = new Date(value2);
    var diff = (dateEnd.getTime() - dateStart.getTime()) / 1000;
    // calculate (and subtract) whole days
    var days = Math.floor(diff / 86400);
    diff -= days * 86400;

    // calculate (and subtract) whole hours
    var hours = Math.floor(diff / 3600) % 24;
    diff -= hours * 3600;

    // calculate (and subtract) whole minutes
    var minutes = Math.floor(diff / 60) % 60;
    diff -= minutes * 60;

    // what's left is seconds
    var seconds = diff % 60; // in theory the modulus is not required
    var x = "";
    if (days > 0) x += days + " día(s), ";
    if (minutes > 0 || days > 0) x += minutes + " minutos(s), ";
    // if(seconds>0)
    x += seconds + " segundos(s) ";
    return x;
  }
  saveExpiresAt(item) {
    let item_t = item;
    item_t.expires_at = formatDate(item_t.expires_at.toISOString());
    var doc_item_id = item_t.id;
    console.log(item_t);
    this.promiseAttachment = this.documentProfileSurveyService
      .updateDocumentProfileSurvey(doc_item_id, item_t)
      .toPromise()
      .then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.notificationsService.growlNotify("success", res);
          });
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg,
                  );
                });
            });
        },
      );
  }
  public gotoAttachmentDocumentCandidate(id) {
    window.open(
      this.apiUrl +
        "/documents-candidate/" +
        id +
        "/attachment" +
        "?token=" +
        localStorage.getItem("token"),
      "_blank",
    );
  }

  public restartTimer() {
    // Detener el temporizador existente
    clearInterval(this.reloadInterval);

    // Reiniciar el temporizador
    this.reloadInterval = setInterval(() => {
      this.filter();
    }, this.timeReload);
  }

  public statusHiring(type) {
    console.log(type);
    if (type != "" && type != undefined) {
      if (type.value == "Reporte Citación - General") return true;
    }
    return false;
  }

  public assignToMeHire(citationId) {
    let citation_id = parseInt(citationId);

    const promise = this.citationService.assignToMeHireCitation(citation_id);
    this.promiseForm = promise.toPromise().then(
      (response) => {
        this.translate
          .get("Process successfully assigned to you")
          .subscribe((res: string) => {
            this.notificationsService.growlNotify("success", res);
            let cit = response.json();

            this.updateItemPropertiesById(this.citations, cit.id, {
              hiring_analyst_id: cit.hiring_analyst_id,
              hiring_analyst_id_n: cit.hiring_analyst.name,
            });
          });
      },
      (error) => {
        this.msgs.push({ severity: "error", summary: "Error" });
      },
    );
  }

  public updateItemPropertiesById(
    items: any[],
    id: number | string,
    updates: Partial<any>,
  ): void {
    const index = items.findIndex((item) => item.id === id);
    if (index !== -1) {
      Object.assign(items[index], updates);
    }
  }
  getResultClass(result: string): any {
    const classMap: { [key: string]: string } = {
      Favorable: "span-favorable",
      "No Apto": "span-unsuitable",
      Novedad: "span-novelty",
      Autorizado: "span-authorized",
      Reingreso: "span-reviewed",
      "Sin Documentos": "span-undocumented",
      "No aplica": "span-not-apply",
    };

    return { [classMap[result] || ""]: true };
  }

  getResultHireClass(resultHire: string): any {
    const classMap: { [key: string]: string } = {
      Contratado: "span-favorable",
      "Candidato desistió": "span-not-assist",
      "Cancelado por el cliente": "span-reviewed",
      Inejecución: "span-unsuitable",
      Inexistencia: "span-unsuitable",
      "No apto en ESC": "span-cancel",
      "No contratado": "span-no-hiring",
    };
    return classMap[resultHire] || "";
  }

  getResultLabel(result: string): string {
    // Por si deseas personalizar el label a mostrar
    return result;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/citations/citations.component.ts